import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'Common/Layout/Page';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import AppointeeDatatable from '../../Datatable/AppointeeDatatable';
import AppointeeColumns from '../../Columns/AppointeeColumns';
import AppointeeContractResponseDataColumns from '../../Columns/AppointeeContractResponseDataColumns';

import {
	getAppointeeContractResponse,
	getAppointeeContractResponseExport,
	getAppointeeContractResponseDetails
} from '../../../../../Redux/Actions/Appointee.Contract.Actions';
import classes from '../appointee-management.module.css';

import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';

const AppointeeContractResponseDataTable = withClsCompTracking('Appointee Contract Response Table')(AppointeeDatatable);

const AppointeeContractResponse = ({ handleActiveModal }) => {
	const dispatch = useDispatch();
	const qualification_year = useSelector(state => state.contract_globals.qualification_year.selected);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const { apiCallCompleted, appointeeData, appointeeDataDetails, appointeeDataExport } = useSelector(state => state.appointeeReducer);
	const handleGetAppointeeContractResponse = (year, contractTypes, query) => dispatch(getAppointeeContractResponse(year, contractTypes, query));
	const handleGetAppointeeContractResponseExport = (year, contractTypes, query) =>
		dispatch(getAppointeeContractResponseExport(year, contractTypes, query));
	const handleGetAppointeeContractResponseDetails = (markingTeamId, year, markingTeamCode, contractTypes, query) =>
		dispatch(getAppointeeContractResponseDetails(markingTeamId, year, markingTeamCode, contractTypes, query));

	return (
		<>
			<Page title="Appointee Contract Response Data">
			</Page>
			<AppointeeContractResponseDataTable
				mainKeyField={'markingTeamTitle'}
				detailsKeyField={'appointeeId'}
				mainColumns={AppointeeColumns()}
				detailsColumns={AppointeeContractResponseDataColumns()}
				contractTypes={types}
				selectedYear={qualification_year}
				handleGetData={handleGetAppointeeContractResponse}
				handleGetDataExport={handleGetAppointeeContractResponseExport}
				handleGetDataDetails={handleGetAppointeeContractResponseDetails}
				apiCallCompleted={apiCallCompleted}
				mainTableData={appointeeData}
				detailsTableData={appointeeDataDetails}
				mainExportData={appointeeDataExport}
				detailsExportData={appointeeDataDetails}
			/>
			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleActiveModal('')} />
			</span>
		</>
	);
};

export default AppointeeContractResponse;
